import { Container, Stack } from "react-bootstrap";
import Header from "./Header";
import { formatDate } from "../util/util";
import build from "../build.json";
import { useTranslation } from "react-i18next";
import PageFactory from "./factories/PageFactory";
import { Page } from "../config/types";
import { getLocale, getMaintenance, maintenanceType, InstallerMap } from "../services/data.service";
import { useEffect, useState } from "react";
import LanguageSwitch from "./LanguageSwitch";
import { useNavigate, useParams } from "react-router-dom";
export type ErrorType = "404"| "maintenance";
export function Error() {
    const { t, i18n } = useTranslation();
    const errorType = useParams().errorType || "404";
    const language = useParams().language;
    const pages = 
          i18n.language === "en"
            ? (i18n.getResource("en","translation","pages") as Page[])
            : (i18n.getResource("es","translation","pages")as Page[]);
    const [currentPage,setCurrentPage] = useState(pages?.find((page)=>page.pageId === errorType));
    const navigate = useNavigate();
    const [languageSupport,setLanguageSupport] = useState({preferred: "",
      en: "",
      es: ""});
    const version=""
    const versionColor=""
    const versionBorderColor=""
    const releaseDate=""
    const installers: InstallerMap = {
      msi: { name: "", size: "", path: "", version: "", artifactName: "", uninstallGuid: "" },
      dmg: { name: "", size: "", path: "", version: "", artifactName: "", uninstallGuid: "" },
      pkg: { name: "", size: "", path: "", version: "", artifactName: "", uninstallGuid: "" },
    };
    const [scheduledEndDate,setScheduledEndDate] = useState("Loading...");
    const renderPage = () => {
      return (
      <>
      {currentPage && 
        <PageFactory
          pageData={currentPage}
          inputJson={undefined}
          version={version}
          versionColor={versionColor}
          versionBorderColor={versionBorderColor}
          releaseDate={releaseDate}
          installers={installers}
          build={build}
          selectedPageId={errorType}
          resetPageSelected={()=>{}}
          scheduledEndDate={scheduledEndDate}
        />
      }
      </>)
    }
    const getMaintenanceError = () => {
      console.error("Maintenance error we are unable to retreive the maintenance end date.");
      navigate(`/${i18n.language}/error/404`);
    }
    useEffect(() => {
        if(language && (language === "en" || language === "es")){
          localStorage.setItem("preferredLanguage",language)
        }
        const preferredLanguage = localStorage.getItem('preferredLanguage');
        if (preferredLanguage) {
          i18n.changeLanguage(preferredLanguage);
        }
    }, [i18n,language]);
    useEffect(() => {
      if(!currentPage){
        getLocale().then((locale) => {
          i18n.addResources("en", "translation", locale.en);
          i18n.addResources("es", "translation", locale.es);
          setLanguageSupport(i18n.language === "en"? locale.en.languageSupport : locale.es.languageSupport)
          const pages = i18n.language === "en"
            ? (locale.en.pages as Page[])
            : (locale.es.pages as Page[]);
          setCurrentPage(pages?.find((page)=>page.pageId === errorType));
          
        });
      }
      else{
        i18n.language === "en"
            ? setCurrentPage(i18n.getResource("en","translation","pages").find((page:any)=>page.pageId === errorType))
            : setCurrentPage(i18n.getResource("es","translation","pages").find((page:any)=>page.pageId === errorType));
      }
      if(languageSupport.preferred === ""){
        getLocale().then((locale) => {
          setLanguageSupport(i18n.language === "en"? locale.en.languageSupport : locale.es.languageSupport)
        });
      }
      if(errorType === "maintenance"){
        getMaintenance(getMaintenanceError).then((maintenance:maintenanceType) => {
            if (maintenance.scheduledEnd) {
              const date = new Date(maintenance.scheduledEnd); 
              const formattedDate = formatDate(date);
              setScheduledEndDate(formattedDate);
            }
          });
        }
    },[languageSupport.preferred,i18n.language,errorType])
    return (
        <Container
                fluid
                style={{
                  top: "0",
                  position: "relative",
                  padding: "0",
                  //  height: "calc(100vh - 4.5rem)",
                  backgroundColor: "whitesmoke",
                }}
              >
        <Header />
        <div className="sticky-language-section">
          <LanguageSwitch
            languageSupport={languageSupport}
          />
        </div>
        <Stack direction="horizontal" gap={0} className="navbar">
          <div className="nav-tab-empty"><br/></div>
        </Stack>

        <div className="error-box">
          {renderPage()}
        </div>
        <footer className="version" role="contentinfo">
          {t("version")}
          {build?.version} {t("releaseDate")}
          {formatDate(new Date(build?.date))}
        </footer>
        </Container>
    )
}
